import styled from "styled-components";
import { COLORS } from "../../../utils/constants";

type ToggleButtonProps = {
  isEnabled: boolean;
};

export const ToggleButton = styled.button<ToggleButtonProps>`
  width: 40px;
  height: 20px;
  position: relative;
  border-radius: 19px;
  border: none;
  background-color: ${COLORS.GREEN};
  background-color: ${({ isEnabled }) =>
    isEnabled ? `${COLORS.GREEN}` : `${COLORS.DARK_GREY}`};
`;

type ToggleDotProps = {
  isEnabled: boolean;
};

export const ToggleDot = styled.div<ToggleDotProps>`
  width: 16px;
  height: 16px;
  left: ${({ isEnabled }) => (isEnabled ? "22px" : "2px")};
  top: 2px;
  position: absolute;
  background-color: ${COLORS.WHITE};
  border-radius: 10px;
`;

export const ToggleTick = styled.div`
  width: 4.33px;
  height: 6px;
  left: 9px;
  top: 5px;
  position: absolute;
  border-radius: 1px;
  border: 2px solid ${COLORS.WHITE};
  transform: rotate(40deg);
  -webkit-transform: rotate(40deg);
  border-width: 0 2px 2px 0;
`;

export const OptionsList = styled.ul`
  width: 600px;
  margin: 0;
  padding: 0;
  &:last-of-type {
    margin-bottom: 40px;
  }
`;

export const OptionCheckbox = styled.div<{ isChecked: boolean }>`
  width: 16px;
  height: 16px;
  margin-right: 10px;
  padding: 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ isChecked }) =>
    !isChecked ? `transparent` : `${COLORS.GREEN}`};
  border: ${({ isChecked }) =>
    !isChecked ? `2px solid ${COLORS.WHITE}` : `2px solid ${COLORS.GREEN}`};
  border-radius: 2px;
`;

export const OptionTick = styled.div`
  width: 5.33px;
  height: 10px;
  border: solid ${COLORS.BLACK};
  border-width: 0 2px 2px 0;
  border-bottom-right-radius: 1px;
  transform: rotate(40deg);
  -webkit-transform: rotate(40deg);
`;

export const ToggleButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
  margin-left: 20px;
`;
